
declare var $: any;
import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpHeaders,
  HttpClientModule,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
  }),
};

@Injectable({
  providedIn: 'root',
})
export class CommonService {
  private _ApiURL = '';
  public LoginUser = [];
  public errorApiMsg = '';
  public successApiMsg = '';
  constructor(private httpclient: HttpClientModule, private http: HttpClient) {}

  GET(path: String): Observable<any> {
    this._ApiURL = environment.APIURL + path;
    console.log('GET :', this._ApiURL);
    return this.http.get(this._ApiURL);
  }
  POST(path: String, Json) {
    this._ApiURL = environment.APIURL + path;
    console.log('POST :', this._ApiURL);
    return this.http.post(this._ApiURL, JSON.stringify(Json), httpOptions);
  }
  // OpenPdfPOST(path: String, Json) {
  //   this._ApiURL = environment.B2CAPI + path;
  //   console.log('POST :', this._ApiURL);
  //   return this.http.post(this._ApiURL, Json, httpOptions);
  // }
  OpenRadiPdfPOST(path: String, Json) {
    this._ApiURL = environment.RADIOLOGISTAPI + path;
    console.log('POST :', this._ApiURL);
    return this.http.post(this._ApiURL, Json, httpOptions);
  }

  fnToastMoveHover(msg) {
    $('.toastDisplay').stop();
    $('.toastDisplay').fadeIn();
    $('.toastDisplay span').html(msg);
    this.errorApiMsg = msg;
    this.fnToastMoveOut();
  }

  fnToastMoveOut() {
    $('.toastDisplay').fadeOut(10000);
  }

  fnOnToastCloseClick() {
    $('.toastDisplay').stop();
    $('.toastDisplay').fadeOut();
    this.errorApiMsg = '';
  }

  fnOnSuccessToastCloseClick() {
    $('.toastDisplaySuccess').fadeOut();
    this.successApiMsg = '';
  }

  fnToastMoveHoverSuccess(msg) {
    $('.toastDisplaySuccess').stop();
    $('.toastDisplaySuccess').fadeIn();
    $('.toastDisplaySuccess span').html(msg);
    this.successApiMsg = msg;
    this.fnToastMoveOutSuccess();
  }

  fnToastMoveOutSuccess = function () {
    $('.toastDisplaySuccess').fadeOut(5000);
  };

  fnShowLoading() {
    document.getElementById('pageoverlay').style.display = 'block';
    document.getElementById('pagespinner').style.display = 'block';
  }

  // Hide loading indicator
  fnHideLoading() {
     document.getElementById('pageoverlay').style.display = 'none';
     document.getElementById('pagespinner').style.display = 'none';
  }
}